import { DotLottie } from '@lottiefiles/dotlottie-web';

import { createFocusTrap } from 'focus-trap';
import { debounce } from '../common/utils';

const MOBILE_MENU_EXPAND_DURATION = 0.75;

let disabled = false;
let animating = false;
let focusTrap = null;

const els = {
    $body: () => $('body'),
    $header: () => $('[data-site-header]'),
    $logoLink: () => els.$header().find('[data-logo-link'),
    $logo: () => els.$logoLink().find('[data-logo'),
    $logoAnimated: () => els.$logoLink().find('[data-logo-animated'),
    $nav: () => els.$header().find('[data-site-nav]'),
    $mobileMenu: () => els.$header().find('[data-mobile-menu]'),
    $mobileMenuToggle: () => els.$header().find('[data-mobile-menu-toggle]'),
    $mobileMenuItems: () => els.$header().find('[data-mobile-menu-item]'),
};

const hide = () => {

    const $header = els.$header();

    gsap.set(
        $header,
        { marginTop: `${-$header.outerHeight()}` }
    );
};

const show = () => {

    if (disabled) {
        return;
    }

    gsap.set(
        els.$header(),
        { marginTop: 0 }
    );
};

const disable = () => {
    disabled = true;
};

const enable = () => {
    disabled = false;
};

const openMobileMenu = () => {

    if (animating) return;

    animating = true;

    const $body = els.$body();
    const $nav = els.$nav();
    const $mobileMenu = els.$mobileMenu();
    const $mobileMenuToggle = els.$mobileMenuToggle();
    const $mobileMenuItems = els.$mobileMenuItems();

    const baseNavHeight = $nav.outerHeight();

    focusTrap.activate();

    $body.css({overflowY: 'hidden'});

    $mobileMenuToggle.attr('data-active', '1');

    if ($nav.attr('data-base-height') === undefined) {
      $nav.attr('data-base-height', baseNavHeight);
    }

    const timeline = gsap.timeline();

    timeline.set($nav, { borderRadius: baseNavHeight * 0.5});

    timeline.to(
        $nav,
        {
            duration: MOBILE_MENU_EXPAND_DURATION,
            height: (
                $nav.outerHeight()
                + $mobileMenu.outerHeight()
            ),
        }
    );

    timeline.set(
        $mobileMenuItems,
        { autoAlpha: 0, },
        '<0.1'
    );

    timeline.set(
        $mobileMenu,
        {
            display: '',
            autoAlpha: 1,
        },
        '>'
    );

    timeline.to(
        $mobileMenuItems,
        {
            autoAlpha: 1,
            stagger: 0.1,
        },
        '>'
    );

    timeline.add(() => animating = false);
};

const resetMobileMenu = () => {

    const $body = els.$body();
    const $nav = els.$nav();
    const $mobileMenu = els.$mobileMenu();
    const $mobileMenuToggle = els.$mobileMenuToggle();

    focusTrap.deactivate();

    $body.css({overflowY: ''});

    $mobileMenuToggle.attr('data-active', '0');

    $nav.removeAttr('data-base-height');

    gsap.set(
        $mobileMenu,
        {
            autoAlpha: 0,
            display: 'none',
        }
    );

    gsap.set(
        $nav,
        {
            borderRadius: '',
            height: '',
        }
    );
};

const closeMobileMenu = () => {

    if (animating) return;

    animating = true;

    const $body = els.$body();
    const $nav = els.$nav();
    const $mobileMenu = els.$mobileMenu();
    const $mobileMenuToggle = els.$mobileMenuToggle();
    const $mobileMenuItems = els.$mobileMenuItems();

    const baseNavHeight = $nav.attr('data-base-height');

    focusTrap.deactivate();

    $body.css({overflowY: ''});

    $mobileMenuToggle.attr('data-active', '0');

    const timeline = gsap.timeline();

    timeline.to(
        $mobileMenuItems,
        {
            autoAlpha: 0,
            stagger: -0.1,
        }
    );

    timeline.set(
        $mobileMenu,
        {
            autoAlpha: 0,
            display: 'none',
        },
        '>'
    );

    timeline.to(
        $nav,
        {
            duration: MOBILE_MENU_EXPAND_DURATION,
            height: baseNavHeight,
        },
        `<-${MOBILE_MENU_EXPAND_DURATION - 0.25}`
    );

    timeline.set(
        $nav,
        {
            borderRadius: '',
            height: '',
        },
    );

    timeline.add(() => animating = false);
};

const isMobileMenuOpen = () => (
    els.$mobileMenuToggle().is('[data-active="1"]')
);

const prepareMobileMenu = () => {

    const $mobileMenu = els.$mobileMenu();
    const $mobileMenuToggle = els.$mobileMenuToggle();

    gsap.set($mobileMenu, { autoAlpha: 0, display: 'none' });
    $mobileMenu.removeClass('hidden');

    focusTrap = (
        createFocusTrap(
            els.$header().get(0),
            { initialFocus: false }
        )
    );

    $mobileMenuToggle.on('click', function(e) {
        e.preventDefault();
        if (isMobileMenuOpen()) {
            closeMobileMenu();
        } else {
            openMobileMenu();
        }
    });

    $(window).on('resize:horizontally', function(){
        resetMobileMenu();
    });

};

const makeSticky = () => {
    const minScroll = 5;
    const scrolledPastTop = 50;
    let didScroll = false;
    let lastScrollTop = 0;

    const adjustNavVisibilityWithScroll = (scrollTop) => {
        if (scrollTop === undefined) {
            scrollTop = $(window).scrollTop();
        }
        const $header = els.$header();
        if (scrollTop > lastScrollTop) {
            // Scroll Down
            if (scrollTop > $header.outerHeight()) {
                hide();
            }
        } else {
            // Scroll Up
            if(scrollTop + $(window).height() >= $(document).height()) return;
            show();
        }
        if (scrollTop > scrolledPastTop) {
            $header.addClass('scrolled');
        } else {
            $header.removeClass('scrolled');
        }
    };

    setInterval(() => {
        if (!didScroll) return;
        let scrollTop = $(window).scrollTop();
        if (Math.abs(lastScrollTop - scrollTop) <= minScroll) return;
        adjustNavVisibilityWithScroll(scrollTop);
        lastScrollTop = scrollTop;
        didScroll = false;
    }, 200);

    $(window).scroll(
        debounce(
            (event) => didScroll = true,
            50
        )
    );

    $(window).resize(
        debounce(
            () => {
                adjustNavVisibilityWithScroll();
            },
            50
        )
    );
};

const prepareSkipMenu = () => {
    $('[data-skip-menu]')
        .on('focus', function() {
            $(this).css('height', 'auto');
        })
        .on('blur', function() {
            $(this).css('height', '');
        })
        .on('keydown', function(e) {
            if (e.keyCode !== 13) return;
            e.stopPropagation();
            $('[data-page-body]')
                .find('[data-hidden-aria-target]')
                .trigger('focus');
        });
};

const prepareLogoAnimation = () => {

    const $header = els.$header();
    const $logo = els.$logo();
    const $logoAnimated = els.$logoAnimated();

    const filename = (
        $header.is('[data-dark]')
            ? 'tdk_topnav_logo_white.lottie'
            : 'tdk_topnav_logo_blue.lottie'
    );

    const dl = new DotLottie({
        canvas: $('[data-logo-animated]').get(0),
        src: `${pageData.themeUrl}/img/animations/${filename}`,
        autoplay: false,
        loop: false,
        stateMachineId: 'StateMachine1',
    });

    dl.addEventListener('load', () => {
        dl.setRenderConfig({
            ...dl.renderConfig,
            freezeOnOffscreen: false,
            autoResize: true,
        });

        gsap.set($logo, { autoAlpha: 0 });
        gsap.set($logoAnimated, { autoAlpha: 1 });
    });
};

const initialize = () => {
    prepareSkipMenu();
    prepareLogoAnimation();
    prepareMobileMenu();
    makeSticky();
};

export default {
    initialize,
    hide,
    show,
    enable,
    disable,
    openMobileMenu,
    closeMobileMenu,
    isMobileMenuOpen,
    els,
};

